var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    width: "35px",
    height: "35px",
    fill: "#2CC1F1",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M670 4626 c-71 -20 -111 -40 -170 -85 -124 -93 -192 -244 -177 -389 4 -34 107 -357 257 -807 137 -412 250 -766 250 -785 0 -19 -113 -373 -250 -785 -150 -450 -253 -773 -257 -807 -18 -167 79 -343 235 -426 113 -60 220 -75 340 -47 41 10 705 311 1806 819 959 443 1778 822 1820 842 43 21 97 55 121 76 125 111 177 303 124 460 -37 111 -95 182 -204 250 -67 42 -3617 1675 -3667 1687 -60 14 -171 13 -228 -3z m1905 -1109 l1720 -797 -1587 0 -1586 0 -247 739 c-242 726 -246 740 -232 774 14 31 50 65 87 80 8 4 40 5 70 3 49 -3 253 -95 1775 -799z m-4 -1913 c-949 -438 -1741 -799 -1762 -801 -83 -12 -169 52 -169 125 0 27 401 1259 475 1460 3 9 331 12 1592 12 l1588 0 -1724 -796z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.ddb2ea7b0c755afe1d78ce8a6eb091f4.svg";
export { ForwardRef as ReactComponent };